// file: src/utils/excelGenerator.js
import * as XLSX from 'xlsx';
import { getLokasiData } from './excelDataFetcher';
import { createExcelData } from './excelDataCreator';
import { applyExcelStyling } from './excelStyling';

// Fungsi utama untuk generate Excel
export const generatePersenBungaExcel = async (groupData) => {
  try {
    if (!groupData || !groupData.items || groupData.items.length === 0) {
      throw new Error('Data tidak tersedia');
    }

    // Ambil data lokasi
    const lokasiData = await getLokasiData(groupData.id_lokasi);
    
    // Siapkan data untuk worksheet
    const excelData = createExcelData(groupData, lokasiData);

    // Buat workbook dan worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Apply styling dengan format tanggal dan number yang baru
    applyExcelStyling(ws, excelData);

    // Tambahkan worksheet ke workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Data Persen Bunga');

    // Generate filename
    const filename = `Persen_Bunga_${groupData.lokasi}_${new Date().toISOString().split('T')[0]}.xlsx`;

    // Download file
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Error generating Excel:', error);
    throw error;
  }
};